import { render, staticRenderFns } from "./choiceUp.vue?vue&type=template&id=5de83f57&scoped=true&lang=pug"
import script from "./choiceUp.vue?vue&type=script&lang=js"
export * from "./choiceUp.vue?vue&type=script&lang=js"
import style0 from "./choiceUp.vue?vue&type=style&index=0&id=5de83f57&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5de83f57",
  null
  
)

export default component.exports